import { CardContent, TextField } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardSpacer from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import RadioGroupField, {
  RadioGroupFieldChoice
} from "@saleor/components/RadioGroupField";
import S3TextField from "@saleor/components/S3TextField";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { commonMessages } from "@saleor/intl";
import { UserError } from "@saleor/types";
import { CoverCoverType, CoverTypeEnum } from "@saleor/types/globalTypes";
import React from "react";
import { IntlShape, useIntl } from "react-intl";

import { CoverPageFormData } from "../CoverPage/CoverPage";

export interface CoverDetailsProps {
  data: CoverPageFormData;
  disabled: boolean;
  onChange: (event: React.ChangeEvent<any>) => void;
  errors: UserError[];
  isNew: boolean;
  setNameValue?: (name, value) => void;
}
function createChoices(intl: IntlShape): RadioGroupFieldChoice[] {
  return [
    {
      label: intl.formatMessage({
        defaultMessage: "Four Map Advertise",
        description: "Cover Type"
      }),
      value: CoverTypeEnum.FOUR_MAP_MASK
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Details's Advertise",
        description: "Cover type"
      }),
      value: CoverTypeEnum.DETAILS
    }
  ];
}

const CoverDetails: React.FC<CoverDetailsProps> = ({
  data,
  disabled,
  onChange,
  setNameValue
}) => {
  const intl = useIntl();
  const choices = createChoices(intl);

  const TargetChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "current window",
        description: "link target for choice"
      }),
      value: "_self"
    },
    {
      label: intl.formatMessage({
        defaultMessage: "new blank tab",
        description: "link target for choice"
      }),
      value: "_blank"
    }
  ];

  return (
    <>
      <Card>
        <CardTitle
          title={intl.formatMessage(commonMessages.generalInformations)}
        />
        <CardContent>
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Plugin Name",
              description: "the name of the Cover converted to"
            })}
            name={"name" as keyof CoverPageFormData}
            fullWidth
            value={data.name}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Title",
              description: "Title"
            })}
            name={"title" as keyof CoverPageFormData}
            fullWidth
            value={data.title}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "SubTitle",
              description: "SubTitle"
            })}
            name={"subtitle" as keyof CoverPageFormData}
            fullWidth
            value={data.subtitle}
            onChange={onChange}
          />
          <FormSpacer />
          <RadioGroupField
            choices={choices}
            disabled={disabled}
            name={"coverType" as keyof CoverPageFormData}
            value={data.coverType}
            onChange={onChange}
          />
        </CardContent>
      </Card>
      <CardSpacer />
      {data.coverType === CoverCoverType.FOUR_MAP_MASK ? (
        <>
          <Card>
            <CardTitle
              title={intl.formatMessage({
                defaultMessage: "Item 1",
                description: "Cover Item 1"
              })}
            />
            <CardContent>
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item1 pc Img",
                  description: "Item1 pc Img"
                })}
                name={"firstImagePc" as keyof CoverPageFormData}
                fullWidth
                value={data.firstImagePc}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item1 pc Img",
                  description: "Item1 pc Img"
                })}
                name={"firstImagePc"}
                value={data.firstImagePc}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item1 mb Img",
                  description: "Item1 mb Img"
                })}
                name={"firstImageMb" as keyof CoverPageFormData}
                fullWidth
                value={data.firstImageMb}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item1 mb Img",
                  description: "Item1 mb Img"
                })}
                name={"firstImageMb"}
                value={data.firstImageMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item1 Link",
                  description: "Item1 Link"
                })}
                name={"firstImageLink" as keyof CoverPageFormData}
                fullWidth
                // error={!!formErrors.firstImageLink}
                // helperText={}
                value={data.firstImageLink}
                onChange={onChange}
              />
              <FormSpacer />
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item1 Text",
                  description: "Item1 Text"
                })}
                name={"firstImageText" as keyof CoverPageFormData}
                fullWidth
                value={data.firstImageText}
                onChange={onChange}
              />
              <FormSpacer />
            </CardContent>
          </Card>
          <CardSpacer />
          <Card>
            <CardTitle
              title={intl.formatMessage({
                defaultMessage: "Item 2",
                description: "Cover Item 2"
              })}
            />
            <CardContent>
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item2 pc Img",
                  description: "Item2 pc Img"
                })}
                name={"secondImagePc" as keyof CoverPageFormData}
                fullWidth
                value={data.secondImagePc}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item2 pc Img",
                  description: "Item2 pc Img"
                })}
                name={"secondImagePc"}
                value={data.secondImagePc}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item2 mb Img",
                  description: "Item2 mb Img"
                })}
                name={"secondImageMb" as keyof CoverPageFormData}
                fullWidth
                value={data.secondImageMb}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item2 mb Img",
                  description: "Item2 mb Img"
                })}
                name={"secondImageMb"}
                value={data.secondImageMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item2 Link",
                  description: "Item2 Link"
                })}
                name={"secondImageLink" as keyof CoverPageFormData}
                fullWidth
                // error={!!formErrors.secondImageLink}
                // helperText={}
                value={data.secondImageLink}
                onChange={onChange}
              />
              <FormSpacer />
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item2 Text",
                  description: "Item2 Text"
                })}
                name={"secondImageText" as keyof CoverPageFormData}
                fullWidth
                value={data.secondImageText}
                onChange={onChange}
              />
            </CardContent>
          </Card>
          <CardSpacer />
          <Card>
            <CardTitle
              title={intl.formatMessage({
                defaultMessage: "Item 3",
                description: "Cover Item 3"
              })}
            />
            <CardContent>
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item3 pc Img",
                  description: "Item3 pc Img"
                })}
                name={"thirdImagePc" as keyof CoverPageFormData}
                fullWidth
                value={data.thirdImagePc}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item3 pc Img",
                  description: "Item3 pc Img"
                })}
                name={"thirdImagePc"}
                value={data.thirdImagePc}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item3 mb Img",
                  description: "Item3 mb Img"
                })}
                name={"thirdImageMb" as keyof CoverPageFormData}
                fullWidth
                value={data.thirdImageMb}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item3 mb Img",
                  description: "Item3 mb Img"
                })}
                name={"thirdImageMb"}
                value={data.thirdImageMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item3 Link",
                  description: "Item3 Link"
                })}
                name={"thirdImageLink" as keyof CoverPageFormData}
                fullWidth
                // error={!!formErrors.thirdImageLink}
                // helperText={}
                value={data.thirdImageLink}
                onChange={onChange}
              />
              <FormSpacer />
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item3 Text",
                  description: "Item3 Text"
                })}
                name={"thirdImageText" as keyof CoverPageFormData}
                fullWidth
                value={data.thirdImageText}
                onChange={onChange}
              />
            </CardContent>
          </Card>
          <CardSpacer />
          <Card>
            <CardTitle
              title={intl.formatMessage({
                defaultMessage: "Item 4",
                description: "Cover Item 4"
              })}
            />
            <CardContent>
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item4 pc Img",
                  description: "Item4 pc Img"
                })}
                name={"fourthImagePc" as keyof CoverPageFormData}
                fullWidth
                value={data.fourthImagePc}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item4 pc Img",
                  description: "Item4 pc Img"
                })}
                name={"fourthImagePc"}
                value={data.fourthImagePc}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item4 mb Img",
                  description: "Item4 mb Img"
                })}
                name={"fourthImageMb" as keyof CoverPageFormData}
                fullWidth
                value={data.fourthImageMb}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item4 mb Img",
                  description: "Item4 mb Img"
                })}
                name={"fourthImageMb"}
                value={data.fourthImageMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item4 Link",
                  description: "Item4 Link"
                })}
                name={"fourthImageLink" as keyof CoverPageFormData}
                fullWidth
                value={data.fourthImageLink}
                onChange={onChange}
              />
              <FormSpacer />
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Item4 Text",
                  description: "Item4 Text"
                })}
                name={"fourthImageText" as keyof CoverPageFormData}
                fullWidth
                value={data.fourthImageText}
                onChange={onChange}
              />
            </CardContent>
          </Card>
          <CardSpacer />
        </>
      ) : (
        <Card>
          <CardTitle
            title={intl.formatMessage({
              defaultMessage: "Listing page ad",
              description: "Details"
            })}
          />
          <CardContent>
            <FormSpacer />
            {/* <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "Details pc Img",
                description: "Details pc Img"
              })}
              name={"detailImagePc" as keyof CoverPageFormData}
              fullWidth
              value={data.detailImagePc}
              onChange={onChange}
            /> */}
            <S3TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "Details pc Img",
                description: "Details pc Img"
              })}
              name={"detailImagePc"}
              value={data.detailImagePc}
              onChange={onChange}
              setNameValue={setNameValue}
            />
            <FormSpacer />
            {/* <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "Details mb Img",
                description: "Details mb Img"
              })}
              name={"detailImageMb" as keyof CoverPageFormData}
              fullWidth
              value={data.detailImageMb}
              onChange={onChange}
            /> */}
            <S3TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "Details mb Img",
                description: "Details mb Img"
              })}
              name={"detailImageMb"}
              value={data.detailImageMb}
              onChange={onChange}
              setNameValue={setNameValue}
            />
            <FormSpacer />
            <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "Details Link",
                description: "Details Link"
              })}
              name={"detailImageLink" as keyof CoverPageFormData}
              fullWidth
              value={data.detailImageLink}
              onChange={onChange}
            />
            <FormSpacer />

            <div style={{ width: "400px" }}>
              <SingleSelectField
                disabled={disabled}
                choices={TargetChoices}
                label={intl.formatMessage({
                  defaultMessage: "Pc details link target",
                  description: "Pc details link target."
                })}
                name="detailLinkTargetPc"
                onChange={onChange}
                value={data.detailLinkTargetPc}
              />
            </div>
            <FormSpacer />
            <div style={{ width: "400px" }}>
              <SingleSelectField
                disabled={disabled}
                choices={TargetChoices}
                label={intl.formatMessage({
                  defaultMessage: "Mb details link target",
                  description: "Mb details link target."
                })}
                name="detailLinkTargetMb"
                onChange={onChange}
                value={data.detailLinkTargetMb}
              />
            </div>
            <FormSpacer />

            <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "Details Text",
                description: "Details Text"
              })}
              name={"detailImageText" as keyof CoverPageFormData}
              fullWidth
              value={data.detailImageText}
              onChange={onChange}
            />
          </CardContent>
        </Card>
      )}
    </>
  );
};
export default CoverDetails;
